<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';
import { provideSidebarLayout } from '../sidebar';

provideSidebarLayout({ navHeight: 56, minWidth: 180 });

onMounted(() => {
  document.body.style.overflow = 'hidden';
});

onBeforeUnmount(() => {
  document.body.style.overflow = '';
});
</script>

<template>
  <slot />
</template>
